import type { FaireProductEntity } from "../../entity_types/product";

export const p_pgcb644jqz: FaireProductEntity = {
  token: "p_pgcb644jqz",
  type: "product",
  name: "Silky Knotted Baby Gown with Knotted Hat - Infant Sleeper",
  brandToken: "b_74b8fwfz3v",
  brandName: "Rocket Bug",
  imageUrl:
    "https://cdn.faire.com/fastly/f8082b4f677357d511156e0e3b905f93d1052a1358ac2cf51afc84f760267db5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d67979b4c52d9179c0585e671457cf84f4b737dde016af4f94dfc002f9301e33.jpeg",
    "https://cdn.faire.com/fastly/6810d1c106839fd19536bea6827f61ccb147b8dfbf62329799d7090ca2b84b7a.jpeg",
    "https://cdn.faire.com/fastly/49935fa14c41b2c2f8c40103d71f2bf9d0ebd40c2080618366f4ce9d608aaf3d.jpeg",
    "https://cdn.faire.com/fastly/5c1b8c1b0d544b508b196a313b16d46b04f8aeddb59db15bd2966ad6cf4e2583.jpeg",
    "https://cdn.faire.com/fastly/613993b695d59adf138192fd810cbad981dc6c134ef5e36f6cd037f204fae454.jpeg",
    "https://cdn.faire.com/fastly/0262d8048d95b1ebdd0eb6bd8d67f8c462db0689ac5cd9b426799388eb21fff9.jpeg",
    "https://cdn.faire.com/fastly/722c9691da8dfe5ad29d0bd3ed4ffd822b0a325b9baf765a476c26a1ffd7b003.jpeg",
    "https://cdn.faire.com/fastly/60899b8b27606f7f153371226074b534b9cf2f4d0353ccb905fd1b9265d41880.jpeg",
    "https://cdn.faire.com/fastly/52d42bad1fdf3cfdda1d8ea55fa48a7544914381204f3cd78e73adf52612245a.jpeg",
    "https://cdn.faire.com/fastly/a23881aa1c87cd3464200ec0b613074dca58281a5c4ff30ccf3d590ebc7bd8b7.jpeg",
    "https://cdn.faire.com/fastly/3dd125e4092ca29bce62bbb848bf031d323304fc3c9b24ddb6bd471b5e834f25.jpeg",
    "https://cdn.faire.com/fastly/1caa3912c23dbe438eac5a7520dcfead5bde84495123dde73e6b11795bfb6e3f.jpeg",
    "https://cdn.faire.com/fastly/2f299b8e0e213b0c890e48c5de541e0c0e2e755130910c8c11e8d7793cab81ea.jpeg",
    "https://cdn.faire.com/fastly/26371e8168aed4858e9571528dc46daa90b38ede670b77fa198453c022589ed5.jpeg",
    "https://cdn.faire.com/fastly/8f6f54de41193130378bc9d4928e1615e3224e1fde59889b16fbddb264bc0d84.jpeg",
  ],
  priceDollars: 12,
  description:
    "\nThis comfy sleeper is perfect for bedtime! Lightweight but warm, the garment is made from a silky, soft material. This sleeper is convenient for diaper changes as it doesn't have to be unbuttoned or unzipped. The knot easily unties so that diaper changes are quick and easy. The knot is also a favorite because it can be adjusted for baby's comfort and size, and gives them plenty of room to wiggle their legs without exposing them to the cold. Because the knot is adjustable, this sleeper lasts longer as your little one grows! \n\nThis garment is 95% cotton and 5% Spandex.\n\n\nNewborn Length: 30\"\n\n0-3 Months Length: 33\"\n\n\n\nAdd a matching blanket! https://shoprocketbug.com/products/rocket-bug-silky-baby-blanket-available-in-many-colors-unisex-boys-girls\n",
  tags: [],
  msrpDollars: 21,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:41.349Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
